import { parseEnv } from '@/utils/parse-env';

export const env = parseEnv();
